import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'aff-manage-products-discounts-page',
  templateUrl: './manage-products-discounts-page.component.html',
  styleUrls: ['./manage-products-discounts-page.component.scss']
})
export class ManageProductsDiscountsPage implements OnInit {
  
  constructor() { }

  ngOnInit() {
  }

}
